import { PostMessageClient } from '@reachmedianetwork/post-message-client';
import {
    AnyPlatformPostMessageApi,
    PmcMessageType,
} from '@reachmedianetwork/post-message-client-rds-api';
import { timeout } from '../../Utility/Timeout';

export type InboundApi = Record<never, never>;
export type OutboundApi = AnyPlatformPostMessageApi;
export type SignsPostMessageClient = PostMessageClient<InboundApi, OutboundApi>;

const MESSAGES_TIMEOUT_SECONDS = 15;

let pmsgClientInstance: SignsMessenger | undefined;

export class SignsMessenger {
    client: SignsPostMessageClient;
    #supportedMessages: Array<string>;

    constructor(client: SignsPostMessageClient, supportedMessages: Array<string>) {
        this.client = client;
        this.#supportedMessages = supportedMessages;
    }

    supports(msgType: string): boolean {
        return this.#supportedMessages.includes(msgType);
    }
}

export async function createSignsPostMessageClient(targetWindow: Window): Promise<SignsMessenger> {
    if (pmsgClientInstance === undefined) {
        const pmsgClient = new PostMessageClient<InboundApi, OutboundApi>(targetWindow);

        const supportedMessages = await timeout(
            pmsgClient.postMessage(PmcMessageType.MessagesGet, undefined),
            MESSAGES_TIMEOUT_SECONDS * 1000
        );
        // just in case an other promise resolved
        if (pmsgClientInstance === undefined) {
            pmsgClientInstance = new SignsMessenger(pmsgClient, supportedMessages);
        }
    }
    return pmsgClientInstance;
}
